import Firebase from '@firebase/app'
import Api from 'dashpoolApi'
import moment from 'moment'
import history from 'store/history'
import { registerAllListeners } from 'registerListeners'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_BOARDING_ERROR = 'CREATE_BOARDING_ERROR'
export const CREATE_BOARDING_SUCCESS = 'CREATE_BOARDING_SUCCESS'
export const UPDATE_BOARDING_ERROR = 'UPDATE_BOARDING_ERROR'
export const UPDATE_BOARDING_SUCCESS = 'UPDATE_BOARDING_SUCCESS'
export const CREATE_BOARDING_REF = 'CREATE_BOARDING_REF'
export const DELETE_BOARDING_REF = 'DELETE_BOARDING_REF'
// ------------------------------------
// Dashpool Actions
// ------------------------------------
export function boardingFinished() {
  return (dispatch, getState) => {
    const { auth } = getState()
    if (auth.rootNode) {
      dispatch({
        type: 'CHANGE_ROOT',
        payload: auth.rootNode
      })
      dispatch(registerAllListeners())
      history.replace('/admin')
    }
  }
}
export function updateSettingsStep(stepIndex) {
  return (dispatch, getState) => {
    const { auth } = getState()
    if (!auth.rootNode) return
    const fanout = {}
    fanout[`users/${auth.uid}/boarding/settings/activeStep`] = Number(stepIndex)
    Firebase.database()
      .ref()
      .update(fanout)
  }
}
export function updateNavigationMenu(index, show) {
  return (dispatch, getState) => {
    const { auth } = getState()
    if (!auth.rootNode) return
    const fanout = {}
    fanout[`users/${auth.uid}/boarding/settings/menu/${index}/show`] = show
    Firebase.database()
      .ref()
      .update(fanout)
  }
}
export function updatePricing(name, value) {
  return (dispatch, getState) => {
    const { auth } = getState()
    if (!auth.rootNode) return
    const fanout = {}
    fanout[`users/${auth.uid}/boarding/settings/pricing/${name}`] = value
    Firebase.database()
      .ref()
      .update(fanout)
  }
}
export function updateTableTypeSettings(name, value) {
  return (dispatch, getState) => {
    const { auth } = getState()
    if (!auth.rootNode) return
    const fanout = {}
    fanout[`${auth.rootNode}/settings/tableTypes/${name}`] = value
    fanout[`users/${auth.uid}/boarding/settings/tableTypes/${name}`] = value
    Firebase.database()
      .ref()
      .update(fanout)
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createHiboutikAccount(config) {
  return (dispatch, getState) => {
    return new Api(dispatch, getState).post(`/hiboutik/createAccount`, {
      config: config
    })
  }
}
export function checkAccountAvailability(accountName) {
  return (dispatch, getState) => {
    return new Api(dispatch, getState).get(`/hiboutik/check/${accountName}`)
  }
}
export function checkAccountCreation(accountName) {
  return (dispatch, getState) => {
    const { auth } = getState()
    new Api(dispatch, getState)
      .get(`/hiboutik/checkCreation/${accountName}`)
      .then(res => {
        if (res.data && res.data.isValid) {
          const fanout = {}
          fanout[
            `users/${auth.uid}/boarding/config/hiboutikAccountVerified`
          ] = true
          fanout[`users/${auth.uid}/boarding/steps/2/isCompleted`] = true
          Firebase.database()
            .ref()
            .update(fanout)
        }
      })
      .catch(err => {
        console.error(err)
      })
  }
}
export function stepComplete(stepIndex, isCompleted) {
  return (dispatch, getState) => {
    const { auth } = getState()
    const fanout = {}
    fanout[
      `users/${auth.uid}/boarding/steps/${stepIndex}/isCompleted`
    ] = isCompleted
    if (stepIndex === 3 && isCompleted) {
      fanout[`users/${auth.uid}/boarding/finished`] = true
    }
    Firebase.database()
      .ref()
      .update(fanout)
    // if (stepIndex === 2) {
    //   fanout[`users/${auth.uid}/rootHbPassword`] = boarding.config.hiboutikPassword
    //   fanout[`users/${auth.uid}/rootNode`] = boarding.config.hiboutikAccount
    //   fanout[`users/${auth.uid}/hiboutikAccount`] = boarding.config.hiboutikAccount
    // }
  }
}
export function updateConfig(name, value) {
  return (dispatch, getState) => {
    const { auth, boarding } = getState()
    const fanout = {}
    fanout[`users/${auth.uid}/boarding/config/updatedAt`] = moment().format()
    fanout[`users/${auth.uid}/boarding/config/${name}`] = value
    fanout[
      `users/${auth.uid}/boarding/steps/${
        boarding.currentStepIndex
      }/isCompleted`
    ] = false
    Firebase.database()
      .ref()
      .update(fanout)
  }
}
export function updateBoarding(changes) {
  return (dispatch, getState) => {
    const { auth } = getState()
    changes.updatedAt = moment().format()
    Firebase.database()
      .ref()
      .child(`users/${auth.uid}/boarding`)
      .update(changes, error => {
        if (error) {
          console.error('ERROR @ updateOnBoarding :', error)
          dispatch({
            type: UPDATE_BOARDING_ERROR,
            payload: error
          })
        }
      })
  }
}

export function registerBoardingListeners() {
  return (dispatch, getState) => {
    const { uid } = getState().auth
    if (!uid) {
      return
    }
    const ref = Firebase.database()
      .ref()
      .child(`users/${uid}/boarding`)
    ref.on('value', snapshot => {
      let boarding = snapshot.val()
      dispatch({
        type: UPDATE_BOARDING_SUCCESS,
        payload: boarding
      })
    })
  }
}

export const actions = {
  updateBoarding
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_BOARDING_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [CREATE_BOARDING_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_BOARDING_SUCCESS]: (state, action) =>
    Object.assign({}, state, action.payload),
  [UPDATE_BOARDING_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { steps: [], finished: false, currentStepIndex: -1 }
export default function boardingReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/boarding.js